import { Model } from '@/models/Model';

export class ContractorFeedback extends Model {
  protected $name = 'ContractorFeedback';

  protected $endpoint = '/hin/contractor-feedback';

  protected $primaryKey = 'uuid';

  protected $fillable: string[] = ['type', 'body', 'contractor'];

  public type?: string;

  public body?: string;

  public contractor?: string;

  public listFeedbackTypes(): Promise<any> {
    const url = '/hin/contractor-feedback/types';
    return this.request('get', url, {}, 'media');
  }
}

export interface CreateFeedbackPayload {
  type: string,
  body: string,
  contractor?: string,
  report?: string,
}
